import React from 'react'

const Manual_interfaz_kiosko = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Interfaz del kiosko
        </h2>
        <iframe
          src="https://scribehow.com/embed/Interfaz_del_kiosko__adIq2Y0jSEm0-dA7xHlueg?as=scrollable"
          className="scribe-iframe-general-76"
          width="100%"
          height="4800"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_interfaz_kiosko
